import { GlButton } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import * as Sentry from '~/sentry/sentry_browser_wrapper';
import { createAlert } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/alert.js?vue3';
import toast from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/plugins/global_toast.js?vue3';
import axios from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/axios_utils.js?vue3';
import { s__ } from '~/locale';
export default {
    name: 'DuoOtelInfo',
    components: {
        GlButton
    },
    props: {
        createWorkflowPath: {
            type: String,
            required: true,
            validator: (value)=>value.startsWith('/')
        }
    },
    data () {
        return {
            isLoading: false
        };
    },
    methods: {
        async startOtelWorkflow () {
            this.isLoading = true;
            try {
                await axios.post(this.createWorkflowPath);
                toast(this.$options.i18n.successMessage);
            } catch (error) {
                Sentry.captureException(error);
                createAlert({
                    message: this.$options.i18n.errorMessage
                });
            } finally{
                this.isLoading = false;
            }
        }
    },
    i18n: {
        buttonText: s__('Observability|Add OpenTelemetry with Duo'),
        successMessage: s__('Observability|OpenTelemetry workflow started'),
        errorMessage: s__('Observability|Failed to start workflow')
    }
};
